var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsGlassdoor = function SvgMillustrationsGlassdoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M25.414 26h5.172c.947 0 1.715-.768 1.715-1.715v-7.12h-1.715v7.12H23.7c0 .947.768 1.715 1.715 1.715m5.172-12h-5.172c-.947 0-1.715.768-1.715 1.715v7.12h1.715v-7.12h6.887c0-.947-.768-1.715-1.715-1.715",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsGlassdoor;